import { render } from "./SubmissionTable.vue?vue&type=template&id=1005b2e5&scoped=true"
import script from "./SubmissionTable.vue?vue&type=script&lang=js"
export * from "./SubmissionTable.vue?vue&type=script&lang=js"

import "./SubmissionTable.vue?vue&type=style&index=0&id=1005b2e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1005b2e5"]])

export default __exports__